import { getData } from "../../api";

export const getExternalOrderSearchSuggestions = async (term) => {
  if (!term || !term.trim()) return [];

  const res = await getData(
    `/admin/orders/external-order/search-suggestions?term=${encodeURIComponent(
      term,
    )}`,
  );

  return res?.success && Array.isArray(res.data) ? res.data : [];
};